// @ts-nocheck
import type {Question, SurveyHandler, SurveyError} from 'src/types/survey';
import type {Answer} from 'src/api-parsers/events';

import logger from 'src/utils/logger';

import * as React from 'react';
import {useSelector} from 'react-redux';
import mapKeys from 'lodash/mapKeys';
import {withFlux} from 'src/flux/component';
import {selectAgencyConfigFlag} from 'src/selectors/agency';

import MessageSurveyModule from './message';
import RatingSurveyQuestion from './rating';
import MultipleChoiceSurveyQuestion from './multiple-choice';
import CalendarDate from './calendar-date';
import TextSurveyQuestion from './text';


type QuestionProps = {
  sentEventId: string;
  question: Question;
  brandColor: string;
  buttonColor: string;
  response?: Answer;
  handleNext?: SurveyHandler;
  currentError: SurveyError;
  isLast: boolean;
  multiEntityEnabled: boolean;
};

const mapper = ({store, ...props}) => {
  let audienceVariables = null;
  const sentEvent = store.sentEvents.byId(props.sentEventId);
  if (sentEvent && sentEvent.entities_data) {
    const entityType = store.survey.byId(sentEvent.eventId)?.entityType;
    audienceVariables = mapKeys(sentEvent.entities_data, (value, key) =>
      key.replace(`${entityType}/`, ''),
    );
  }
  return {
    audienceVariables,
  };
};

// TODO(marcos): is SurveyHandler really optional here?
const SurveyQuestionComponent = ({
  question,
  response,
  handleNext,
  brandColor,
  buttonColor,
  currentError,
  isLast,
  multiEntityEnabled,
  sentEvent,
  audienceVariables,
  recipientEntityType,
  currentResponse,
  writebackFieldAttributes,
}: QuestionProps) => {
  const {type} = question;
  const atsFieldWritebackEnabled = useSelector((state) =>
    selectAgencyConfigFlag(state, 'atsFieldWritebackEnabled'),
  );

  const questionProps = {
    data: question,
    response,
    handleNext,
    brandColor,
    buttonColor,
    currentError,
    audienceVariables,
    atsFieldWritebackEnabled,
    fetching: !currentResponse,
    writebackFieldAttributes,
  } as const;

  switch (type) {
    case 'message_survey_module':
      return (
        <MessageSurveyModule
          data={question}
          handleNext={handleNext}
          brandColor={brandColor}
          buttonColor={buttonColor}
          isLast={isLast}
          multiEntityEnabled={multiEntityEnabled}
        />
      );
    case 'nps_survey_question':
      return <RatingSurveyQuestion type="nps" {...questionProps} />;
    case 'rating_scale_survey_question':
      return <RatingSurveyQuestion {...questionProps} />;
    case 'multiple_choice_survey_question':
      return <MultipleChoiceSurveyQuestion {...questionProps} />;
    case 'text_survey_question':
      return <TextSurveyQuestion {...questionProps} />;
    case 'calendar_date_survey_question':
      return <CalendarDate {...questionProps} />;
    default:
      logger.error(`this question type: "${type}"" has no renderer (yet)`);
      return <div />;
  }
};

export default withFlux(mapper)(SurveyQuestionComponent);
